import AAFPlayer from "../../../../AAFPlayer/AAFPlayer";

interface ITierTarget {
  w: number;
  h: number;
}

interface ITarget {
  FHD: ITierTarget;
  HD: ITierTarget
}

export const getVideoElements = () => {
  const videoPlayerMain: HTMLElement | null = document.querySelector("#playerMain") || null
  const videoFull: HTMLElement | null = document.querySelector("#Html5PlayerContainer_full") || null
  return {videoPlayerMain, videoFull}
}

export const transformStylesToPip = (elementTarget: HTMLElement, videoElement: HTMLElement) => {
  const {top, left, width, height} = elementTarget.getBoundingClientRect()
  if (videoElement) {
    videoElement.style.zIndex = '10000000000';
    AAFPlayer.setPlayerSize(false, top, left, width, height)
  }
}
export const resetStylesToFullScreen = () => {
  const {videoPlayerMain = null} = getVideoElements()

  if (videoPlayerMain) {
    videoPlayerMain.style.zIndex = '0';


    AAFPlayer.setPlayerSize(false, 0, 0, 1280, 720)
  }
}

export const createPipVideo = (elementId: string) => {
  const {videoPlayerMain} = getVideoElements()
  const elementTarget: HTMLElement | null = document.querySelector(elementId) || null
  elementTarget && videoPlayerMain && transformStylesToPip(elementTarget, videoPlayerMain)
}


// WEBPACK FOOTER //
// ./src/components/Video/pip/utils/utilsPipVideo.ts